<template>
  <v-btn
    @click="buttonFunction(functionParameters)"
    :loading="loading"
    :disabled="disabled"
    color="primary"
    tile
    class="mx-1 px-9"
    height="50px"
  >
    <slot name="prepend"></slot>
    <template v-slot:loader>
      <span class="rai-custom-loader__button">
        <v-icon dark>mdi-cached</v-icon>
      </span>
    </template>
    {{ buttonLabel }}
    <slot name="append"></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'RaisonButton',

  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    buttonFunction: {
      type: Function,
      required: true,
    },
    functionParameters: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  }
};
</script>

<style>
/* Loading buttons */
.rai-custom-loader__button {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>